import * as React from 'react';
import styled from 'styled-components';

const DateOfStory = styled.time`
	color: grey;
	display: block;
	font-size: 18px;
	margin-bottom: 0.5rem;
	margin-top: 0;
	text-transform: uppercase;

	@media(${(props) => props.theme.mediumUp}) {
		margin-top: 0.4rem;
		margin-bottom: 1rem;
	}
`;

const Date = ({ children }: any) => (
	<DateOfStory>{children}</DateOfStory>
);

export default Date;
